import Component from './component';

export interface Props {
    logo: string;
    logoAlt?: string;
}

Component.defaultProps = {};

export default Component;